import { useState } from "react";
import { motion } from "framer-motion";
import { api } from "../lib/api";
import RevealText from "../components/RevealText";
import ScrollReveal from "../components/ScrollReveal";
import TonalPanel from "../components/TonalPanel";
import { CONTACT } from "../constants/testIds";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setState("loading");
    try {
      await api.post("/contact", form);
      toast.success("Received. The house will be in quiet correspondence.");
      setState("ok");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch {
      toast.error("A quiet issue. Kindly try again.");
      setState("idle");
    }
  };

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <div className="pt-32 md:pt-44">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-6 mb-16 md:mb-24">
        <div className="col-span-12 md:col-span-4">
          <p className="text-[10px] uppercase tracking-eyebrow text-ink/60">Correspondence</p>
          <p className="mt-2 text-[11px] uppercase tracking-editorial text-ink/70">The house replies personally.</p>
        </div>
        <div className="col-span-12 md:col-span-8">
          <RevealText
            as="h1"
            className="font-serif-display text-[13vw] md:text-[9vw] leading-[0.9] tracking-[-0.02em] max-w-[16ch]"
            lines={["Write to", <span key="i" className="italic font-serif-italic">the House</span>]}
          />
        </div>
      </div>

      <div className="max-w-[1600px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-6 md:gap-16 pb-32">
        <ScrollReveal className="col-span-12 md:col-span-5 md:sticky md:top-32 h-max space-y-12">
          <div>
            <p className="text-[10px] uppercase tracking-editorial text-ink/55 mb-3">Post</p>
            <p className="font-serif-display text-2xl md:text-3xl leading-[1.15]">
              House of Korv<br />
              32 Redchurch Street<br />
              London E2 7DP
            </p>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-editorial text-ink/55 mb-3">Press &amp; partnerships</p>
            <p className="text-[16px]">press@houseofkorv.com</p>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-editorial text-ink/55 mb-3">Client care</p>
            <p className="text-[16px]">care@houseofkorv.com</p>
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-editorial text-ink/55 mb-3">Ateliers</p>
            <p className="text-[16px] leading-[1.65]">London · Copenhagen · Tokyo</p>
          </div>
          <div className="aspect-[4/3]">
            <TonalPanel
              bg="stone"
              tubeColor="#3a2530"
              cap="same"
              sublabel="LIP GLOSS"
              fig="London · Redchurch"
              caption="The house replies personally."
              chapter="Correspondence"
              ratio="aspect-[4/3]"
            />
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.1} className="col-span-12 md:col-span-6 md:col-start-7">
          <form data-testid={CONTACT.form} onSubmit={submit} className="space-y-10">
            <div>
              <label className="text-[10px] uppercase tracking-editorial text-ink/55">Your name</label>
              <input data-testid={CONTACT.name} value={form.name} onChange={set("name")} required className="field mt-2" />
            </div>
            <div>
              <label className="text-[10px] uppercase tracking-editorial text-ink/55">Your address</label>
              <input data-testid={CONTACT.email} type="email" value={form.email} onChange={set("email")} required className="field mt-2" />
            </div>
            <div>
              <label className="text-[10px] uppercase tracking-editorial text-ink/55">Subject</label>
              <input data-testid={CONTACT.subject} value={form.subject} onChange={set("subject")} placeholder="Private appointment, press, wholesale …" className="field mt-2" />
            </div>
            <div>
              <label className="text-[10px] uppercase tracking-editorial text-ink/55">Message</label>
              <textarea data-testid={CONTACT.message} value={form.message} onChange={set("message")} rows={6} required className="field mt-2 resize-none" />
            </div>
            <motion.button
              whileTap={{ scale: 0.98 }}
              data-testid={CONTACT.submit}
              disabled={state === "loading"}
              className="text-[11px] uppercase tracking-editorial pb-2 border-b border-ink"
            >
              {state === "loading" ? "Sending —" : "Send Correspondence →"}
            </motion.button>
          </form>
        </ScrollReveal>
      </div>
    </div>
  );
}
